import React from 'react';
import { hackyServerSideTranslations } from '../../../i18nNext';
import LandingPageLayout from '../../../components/layout/LandingPageLayout';
import ProfileLandingPage from '../../../components/profileLandingPage/ProfileLandingPage';
import { getSkillRoles, getSkillRoleBySlug } from '../../../store/skills/skills.services';
import * as Sentry from '@sentry/nextjs';
import PropTypes from 'prop-types';
import { buildSimpleHead } from '../../../components/layout/heading';
import { cdnize } from '../../../utils/pureUtils';

const LandingPage = ({ role }) => {
  return <ProfileLandingPage preloadedRole={role} />;
};

/* eslint-disable react/prop-types */
LandingPage.getHead = () => props => {
  const imageLink = cdnize('/meta/lp-meta.jpg');

  const DefaultHeader = buildSimpleHead(props.role.slug);
  return <DefaultHeader {...props} twitterImageLink={imageLink} imageLink={imageLink} />;
};

LandingPage.getLayout = () => LandingPageLayout;
LandingPage.propTypes = {
  role: PropTypes.object
};

export async function getStaticPaths({ locales }) {
  const skillRoles = await getSkillRoles();
  const roles = skillRoles.filter(r => r.slug !== r.category);
  const localRoles = [];
  for (const locale of locales) {
    localRoles.push(...roles.map(({ category, slug }) => ({ params: { categoryName: category, role: slug }, locale })));
  }
  return {
    paths: localRoles,
    fallback: false
  };
}

export async function getStaticProps({ locale, params }) {
  const i18nConfig = await hackyServerSideTranslations(locale);
  try {
    const role = await getSkillRoleBySlug(params.role);
    return { props: { role, ...i18nConfig } };
  } catch (e) {
    Sentry.captureException(e);
    return { props: { role: null, ...i18nConfig } };
  }
}

export default LandingPage;
